import * as tslib_1 from "tslib";
import { Component, Children } from 'react';
import PropTypes from 'prop-types';
import onClickOutside from 'react-onclickoutside';
import noop from 'lodash/noop';
import { compose, setPropTypes } from 'recompose';

var ClickOutside =
/** @class */
function (_super) {
  tslib_1.__extends(ClickOutside, _super);

  function ClickOutside() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.handleClickOutside = function (event) {
      _this.props.onClickOutside(event);
    };

    return _this;
  }

  ClickOutside.prototype.render = function () {
    return Children.only(this.props.children);
  };

  ClickOutside.propTypes = {
    onClickOutside: PropTypes.func,
    children: PropTypes.node
  };
  ClickOutside.defaultProps = {
    onClickOutside: noop
  };
  return ClickOutside;
}(Component);

export default compose(setPropTypes(ClickOutside.propTypes), onClickOutside)(ClickOutside);

try {
  // @ts-ignore
  ClickOutside.__docgenInfo = {
    "description": "",
    "displayName": "ClickOutside",
    "props": {
      "onClickOutside": {
        "defaultValue": null,
        "description": "",
        "name": "onClickOutside",
        "required": true,
        "type": {
          "name": "(event: MouseEvent<Element>) => void"
        }
      },
      "disableOnClickOutside": {
        "defaultValue": null,
        "description": "",
        "name": "disableOnClickOutside",
        "required": false,
        "type": {
          "name": "boolean | undefined"
        }
      },
      "eventTypes": {
        "defaultValue": null,
        "description": "",
        "name": "eventTypes",
        "required": false,
        "type": {
          "name": "string | string[] | undefined"
        }
      },
      "outsideClickIgnoreClass": {
        "defaultValue": null,
        "description": "",
        "name": "outsideClickIgnoreClass",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "preventDefault": {
        "defaultValue": null,
        "description": "",
        "name": "preventDefault",
        "required": false,
        "type": {
          "name": "boolean | undefined"
        }
      },
      "stopPropagation": {
        "defaultValue": null,
        "description": "",
        "name": "stopPropagation",
        "required": false,
        "type": {
          "name": "boolean | undefined"
        }
      }
    }
  };
} catch (__react_docgen_typescript_loader_error) {}